import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { LetDirective } from '@directives/app-let.directive';
import { Store } from '@ngrx/store';
import { CookieStorageService } from '@services/cookie-storage/cookie-storage.service';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { PreviousSearchService } from '../../services/previous-search.service';
import { CULTURE_ROUTE_PARAM, CultureKeyType } from '@constants/app.constants';
import { selectIsHomePage, selectRouteParam } from '@selectors/router.selector';
import { Observable } from 'rxjs';
import { selectAppCmsCopy } from '@selectors/cms.selector';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { Station } from '@models/responses/station-response.model';
import { StationNamePipe } from '@pipes/station-name/station-name.pipe';
import { DateFormats } from '@constants/date-format.constants';
import { availabilitySearchByQueryParams } from '@actions/availability.action';
import { SearchRequestWitchTripType } from '@models/requests/search-request.model';
import { TripType } from '@constants/home.constants';

@Component({
  selector: 'app-previous-search',
  standalone: true,
  imports: [
    CommonModule,
    LetDirective,
    SvgIconComponent,
    StationNamePipe,
  ],
  templateUrl: './previous-search.component.html',
  styleUrl: './previous-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviousSearchComponent implements OnInit {

  @Input() stations: Station[] | null;
  @Output() lastSearchClicked = new EventEmitter<boolean>();
  
  lastSearch$ = this.previousSearchService.getLastSearchData();
  culture$ = this.store.select(
    selectRouteParam(CULTURE_ROUTE_PARAM),
  ) as Observable<CultureKeyType | undefined>;
  cmsAppCopy$ = this.store.select(selectAppCmsCopy);
  isHomePage$ = this.store.select(selectIsHomePage);
  
  readonly gbf = GrowthBookFeatureKeys;
  readonly dateFormats = DateFormats;
  readonly TripType = TripType;
  
  constructor(
    private previousSearchService: PreviousSearchService,
    private store: Store,
    private cookieStorage: CookieStorageService,
    public gbs: GrowthBookService,
  ) {}

  ngOnInit(): void {
    this.previousSearchService.getLastSearchCookie();
  }

  deleteSearchCookie(): void {
    this.cookieStorage.removeCookie(CookieStorageService.lastSearchCookie);
    this.previousSearchService.clearLastSearchData();
  }

  applyLastSearch(lastSearch: SearchRequestWitchTripType): void {
    const isTravelersStart =
      this.gbs.growthBook.isOn(this.gbf.FEAT_US458_TRAVELERS_FIRST_IN_FLOW) &&
      this.gbs.growthBook.getFeatureValue(this.gbf.FEAT_US458_TRAVELERS_FIRST_IN_FLOW, '') === 'b';
    const isSeatsBeforeBags = this.gbs.isVariantOfExperimentEnabled('feat-002379-seatmap-PremiumUpgrade', 'b');
    this.lastSearchClicked.emit(true);
    this.store.dispatch(
      availabilitySearchByQueryParams({
        payload: lastSearch,
        sourceOrganization: '',
        tripType: lastSearch.tripType,
        redirectId: '',
        isTravelersStart: isTravelersStart,
        isSeatsBeforeBags: isSeatsBeforeBags,
      })
    )
  }
}
